import { env } from './env';
import { DEFAULT_APP_VERSION, PERFORMANCE_BASE_URL } from './conf';
import { getPublisherByType } from './publishers/publishers';
import Reporter from './reporter/reporter';
import BaseLogger from './base-logger';
import WidgetLogger from './widget-logger';
import { initializeFedopsApps } from './app-data/app-data';

let ReporterFactory = Reporter;

/*
 * @param baseUrl
 * @param appId
 * @param isWidgetLogger
 * @param disableAutoLoadFinish
 * @param interactionTimeout
 * @param timeoutHook
 * @param startHook
 * @param endHook
 * @param publisher
 */
export function create(appName, params = {}) {
  if (!appName) {
    return null;
  }

  initializeFedopsApps();

  const appVersion = env().__CI_APP_VERSION__ || DEFAULT_APP_VERSION;
  const reporter = createReporterInstance(params);

  if (params.isWidgetLogger) {
    return new WidgetLogger(appName, appVersion, reporter, params);
  }

  return new BaseLogger(appName, appVersion, reporter, params);
}

export function setFactory(factory) {
  ReporterFactory = factory;
}

function createReporterInstance(params) {
  const publisher = getPublisherByType(params.publisher);

  try {
    return new ReporterFactory(params.baseUrl, PERFORMANCE_BASE_URL, publisher);
  } catch (err) {
    return ReporterFactory(params.baseUrl, PERFORMANCE_BASE_URL, publisher); // eslint-disable-line
  }
}
